import { createGlobalStyle } from "styled-components";
import { ColorsBase } from "./colors_base";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Bubbleboddy Normal";
        src: url("/fonts/Bubbleboddy-ExtraLightTrial.ttf") format("truetype");
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: "Bubbleboddy Bold";
        src: url("/fonts/Bubbleboddy-FatTrial.ttf") format("truetype");
        font-weight: bold;
        font-style: bold;
    }


    body,
    html,
    a {
        font-family: 'Bubbleboddy Normal', sans-serif;
        font-weigth: 500;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        overflow-x: hidden;
        background-image: linear-gradient(to right, ${ColorsBase.blue3}, ${ColorsBase.pink3});
        background-repeat: repeat;
        background-position: top right;
        background-size: cover;
        color: white;
    }

    body::before {
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: fixed;
        background-image: radial-gradient(${ColorsBase.halftoneDotColor} 1px, transparent 0);
        background-size: 10px 10px;
        pointer-events: none;
        z-index: -1;
    }

    body::after {
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -20;
        pointer-events: none;
        background-image: url("/img/svg/bg.svg");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        opacity: 0.2;
  }  

    a:hover {
        color: #18216d;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Bubbleboddy Bold', serif;
        color: ${ColorsBase.pink1};
        font-size: 56px;
        line-height: 1.18;
        letter-spacing: 2px;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: white;
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #2E186A;

        :hover {
            color: #2e186a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }

    .no-bubbleboddy {
        font-family: none !important;
    }

    .download-anchor {
        color: white;
        cursor: pointer;
        transition: all 0.3s ease-in-out;

        &:hover,
        &:active,
        &:focus {
            color: ${ColorsBase.orange1};
            text-underline-position: under;
            text-decoration: ${ColorsBase.orange1} wavy underline;
        }
    }
`;
